import { initialState } from "./state"

export default {
  setBillingAddress: (state, payload) => {
    Object.keys(state.billingAddress).forEach(key => {
      if (payload[key] !== undefined) {
        state.billingAddress[key] = payload[key]
      }
    })
  },
  resetBillingAddress: state => {
    state.billingAddress = initialState().billingAddress
    state.complements = []
  },
  resetBilling: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  }
}
